<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
                <!-- 右边主要区 -->
                <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                    <!-- 右边头部搜索区 -->
                    <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="110px">
                                <!-- 字典名称 -->
                                <el-form-item :label="columnInfo.name.label" prop="name">
                                        <el-input v-model="queryParams.param.name" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 字典编码 -->
                                <el-form-item :label="columnInfo.code.label" prop="code">
                                        <el-input v-model="queryParams.param.code" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 备注 -->
                                <el-form-item :label="columnInfo.comment.label" prop="comment">
                                        <el-input v-model="queryParams.param.comment" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 状态 -->
                                <el-form-item :label="columnInfo.state.label" prop="state">
                                        <enum-dict-select v-model="queryParams.param.state" module-name="system" dict-code="state"  placeholder="请选择" size="small" clearable/>
                                </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="clickSearch">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 右边中部功能区 -->
                    <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                        <el-col :span="1.5">
                            <el-button
                                    type="primary"
                                    plain
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="clickAdd"
                                    v-permissionDisabled="'system:dictionary:create'"
                            >新增</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-import-plus title="系统字典表" module-name="system" table-name="dictionary" :permission-code="'system:dictionary:import'"></excel-import-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-plus file-name="系统字典表" module-name="system" table-name="dictionary" :select-list="selectList" :permission-code="'system:dictionary:export'"></excel-export-plus>
                        </el-col>
                        <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                                            :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                    </el-row>
                    <!-- 右边中部表格区 -->
                    <div class="main">
                        <div class="table">
                            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                      @selection-change="handleSelectionChange" height="100%" :header-cell-style="{background:'#ECF5FF'}">
                                <el-table-column align="center" type="selection" width="55"/>
                                        <!-- 字典名称 -->
                                        <el-table-column align="center" prop="name" :label="columnInfo.name.label" v-if="columnInfo.name.visible">
                                        </el-table-column>
                                        <!-- 字典编码 -->
                                        <el-table-column align="center" prop="code" :label="columnInfo.code.label" v-if="columnInfo.code.visible">
                                          <template slot-scope="scope">
                                            <el-link type="primary" @click="linkDictionaryItem(scope.row)">{{scope.row.code}}</el-link>
                                          </template>
                                        </el-table-column>
                                        <!-- 备注 -->
                                        <el-table-column align="center" prop="comment" :label="columnInfo.comment.label" v-if="columnInfo.comment.visible">
                                        </el-table-column>
                                        <!-- 状态 -->
                                        <el-table-column align="center" prop="state" :label="columnInfo.state.label" v-if="columnInfo.state.visible">
                                            <template v-slot="scope">
                                                <enum-dict-label v-model="scope.row.state" dict-code="state" module-name="system" show-tag></enum-dict-label>
                                            </template>
                                        </el-table-column>
                                <!-- 操作列 -->
                                <el-table-column align="center" label="操作" width="350" fixed="right">
                                    <template v-slot="scope">
                                        <el-button @click="clickEdit(scope.row)" type="primary" size="mini" v-permissionDisabled="'system:dictionary:update'">编辑</el-button>
                                        <el-button @click="clickDel(scope.row)" type="danger" size="mini" v-permissionDisabled="'system:dictionary:remove'">删除</el-button>
                                        <el-button @click="linkDictionaryItem(scope.row)" type="success" size="mini">管理字典项</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!-- 右边底部分页区 -->
                    <div style="height: 40px;margin-bottom: 0.1rem;">
                        <pagination-plus :totalCount="totalCount"
                                         :param="queryParams"
                                         :pageSizes="pageSizes"
                                         :selectList="selectList"
                                         module-name="system"
                                         table-name="dictionary"
                                         :del-all-permission-code="'system:dictionary:removes'"
                                         :state-permission-code="'system:dictionary:state'"
                                         @handleTableRefresh="handleTableSearch"/>
                    </div>
                </el-col>
        </el-row>
        <!-- 弹出层组件 -->
        <dictionaryForm/>
    </div>
</template>

<script>
    /**
     * 系统字典表主页面 （与自定义组件之间请遵循MVVM架构）
     * @author PeterLee
     * @since 2024-06-13
     */
    import dictionaryForm from "./DictionaryForm.vue"
    import {mapState, mapMutations, mapActions} from "vuex";
    import {registerStore, unregisterStore} from "@/utils/common";
    import dictionaryDataProvider from "./DictionaryDataProvider";

    export default {
        components: {
            // 表单弹出组件
            dictionaryForm
        },
        data() {
            return {
                // 每页条数选项（分页控件）
                pageSizes: [10, 20, 40, 80],
                // 批量操作选中list（分页控件）
                selectList: [],
                // 展示搜索区（right-toolbar）
                showSearch: false,
                // 导出loading
                exportLoading: false,
            }
        },
        computed: {
            ...mapState({
                // 表格数据
                tableData: state => state.system.dictionary.tableData,
                // 下拉选项
                options: state => state.system.dictionary.options,
                // 共有数据条数（分页控件）
                totalCount: state => state.system.dictionary.totalCount,
                // 列信息
                columnInfo: state => state.system.dictionary.columnInfo,
                // 查询参数
                queryParams: state => state.system.dictionary.queryParams,
                // 时间范围
                dateRange: state => state.system.dictionary.dateRange,
                // 更多按钮信息
                moreButtonProps: state => state.system.dictionary.moreButtonProps,
            })
        },
        // 生命周期create函数
        created() {
            // 注册vuex模块
            registerStore('system','dictionary',dictionaryDataProvider);
            // 创建时获取所有权限数据（分页查询）
            this.handleTableSearch();
            // 获取OptionList
            this.getOptionList();
        },
        // 生命周期销毁函数
        destroyed() {
            // 解绑vuex模块
            unregisterStore('system','dictionary');
        },
        methods: {
            ...mapMutations({
                clickEdit: 'system/dictionary/clickEdit',
                clickAdd: 'system/dictionary/clickAdd',
            }),
            ...mapActions({
                clickDel: 'system/dictionary/handleDel',
                handleTableSearch: 'system/dictionary/handleTableSearch',
                getOptionList: 'system/dictionary/getOptionList',
            }),
          //跳转到字典项页面
          linkDictionaryItem(row) {
            this.$router.push({name: 'DictionaryItemManage/:id', params: {id: row.id}})
          },
            /** 重置按钮点击（搜索区） */
            clickReset() {
                for (let key of Object.keys(this.dateRange)) {
                    this.dateRange[key] = []
                }
                this.$refs['queryForm'].resetFields();
                this.handleTableSearch();
            },
            /** 搜索按钮点击（搜索区） */
            clickSearch() {
                this.queryParams.currPage = 1;
                this.handleTableSearch();
            },
            /** 处理选择改变（表格区） */
            handleSelectionChange(selectList) {
                this.selectList = selectList;
            },
            /** 重新计算表格（按钮区） */
            redoTableLayout() {
                // 数据加载完成后执行
                this.$nextTick(() => {
                    // 表格重新渲染
                    this.$refs.multipleTable.doLayout();
                });
            },
            /** 更多按钮方法处理（按钮区） */
            handleCommand(command,row) {
                // console.log(command)
                // console.log(row)
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/assets/style/index.less');

    ::v-deep .el-form-item {
        margin-bottom: 18px;
    }
</style>
